/* eslint-disable react/prop-types */
import { Box, Grid, Tab, Tabs, Typography } from "@mui/material";
import CustomTabPanel from "components/CustomPanel/customPanel";
import useAuth from "hooks/useAuth";
import { Fragment, useEffect, useMemo, useState } from "react";
import { checkGroupUser } from "utils/constants";
import {
  ID_GROUP_NUMBER_ONE,
  ID_GROUP_CAPTINH,
  ID_GROUP_NUMBER_SEVEN,
  ID_GROUP_PHUONGXA,
  API_ROUTES_V2,
  ID_GROUP_HOIDONG,
} from "utils/constants";
import { JsonTool } from "utils/jsonTools";
import dayjs from "dayjs";
import { useSetRecoilState } from "recoil";
import { AlertState } from "states";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import IconDownload from "components/IconDownload";

export default function ShowSanPhamOCOP({ data }) {
  const axiosPrivateInstance = useAxiosPrivate();
  const setAlert = useSetRecoilState(AlertState);
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuth();
  const [value, setValue] = useState(0);
  const [sanPham, setSanPham] = useState(); //state thông tin sản phẩm đăng ký
  const [dataChamDiem, setDataChamDiem] = useState(); //lấy hồ sơ chấm điểm trả về thông tin các điểm đã chấm trước đó
  const [dataChamDiemHoiDongCapHuyen, setDataChamDiemHoiDongCapHuyen] =
    useState(); //lấy hồ sơ chấm điểm hội đồng cấp huyện
  const [dataChamDiemHoiDongCapTinh, setDataChamDiemHoiDongCapTinh] =
    useState(); //lấy hồ sơ chấm điểm hội đồng cấp tỉnh

  //kiểm tra đang đăng nhập với nhóm hội đồng = 6
  const isHoiDong = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_HOIDONG);
  }, [user]);

  //Kiểm tra nhóm người dùng là 1
  const isGroupNumberOne = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_NUMBER_ONE);
  }, [user]);
  //kiểm tra nhóm người dùng là 9 - cấp tỉnh
  const isGroupNumberNine = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_CAPTINH);
  }, [user]);
  //kiểm tra nhóm người dùng là 7
  const isGroupNumberSeven = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_NUMBER_SEVEN);
  }, [user]);
  //kiểm tra nhóm người dùng là 8 - phường/xã
  const isGroupNumberEight = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_PHUONGXA);
  }, [user]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  //change file
  const handleErrorDownload = (error) => {
    setAlert({
      alert: true,
      message: error,
      type: "error",
    });
  };
  useEffect(() => {
    const fetchDataDangKySanPham = (id) => {
      setIsLoading(true);
      axiosPrivateInstance
        .get(API_ROUTES_V2.PHIEUDANGKY + "/" + id)
        .then((response) => {
          const data = response.data;
          setSanPham(data);
          setDataChamDiemHoiDongCapHuyen(data.hoidong_caphuyen);
          setDataChamDiemHoiDongCapTinh(data.hoidong_captinh);
        })
        .catch((error) => {
          setAlert({
            alert: true,
            message: error?.message || "Lỗi!",
            type: "error",
          });
        })
        .finally(() => {
          setIsLoading(false);
        });
    };
    if (data?.id) {
      fetchDataDangKySanPham(data?.id);
    }
    return () => {
      setSanPham(null);
    };
  }, [data]);
  //các trường thông tin của form đăng ký sản phẩm cần đánh giá
  const dataInfor = useMemo(() => {
    const result = [
      {
        key: "bosanpham_ten",
        name: "Bộ sản phẩm",
      },
      {
        key: "nhomsanpham_ten",
        name: "Nhóm sản phẩm",
      },
      {
        key: "sanpham_ten",
        name: "Tên sản phẩm",
      },
      {
        key: "sanpham_ma",
        name: "Mã số sản phẩm",
      },
      {
        key: "chuthe_ten",
        name: "Tên chủ thể sản xuất",
      },
      {
        key: "chuthe_diachi",
        name: "Địa chỉ",
      },
      {
        key: "chuthe_dienthoai",
        name: "Điện thoại",
      },
      {
        key: "chuthe_email",
        name: "Email",
      },
      {
        key: "chuthe_nguoidaidienphapluat",
        name: "Đại diện pháp luật",
      },
      {
        key: "chuthe_loaihinh",
        name: "Loại hình",
      },
      {
        key: "chuthe_dantoc",
        name: "Dân tộc",
      },
      {
        key: "chuthe_gioitinh",
        name: "Giới tính",
      },
    ];
    return result;
  }, []);
  const dataContent = useMemo(() => {
    const result = [
      {
        key: "noidung_nguongoc",
        name: "Sử dụng nguyên liệu địa phương:",
      },
      {
        key: "noidung_laodong",
        name: "Sử dụng lao động địa phương:",
      },
      {
        key: "noidung_ytuong",
        name: "Nguồn gốc ý tưởng sản phẩm:",
      },
      {
        key: "noidung_bansac",
        name: "Bản sắc/Trí tuệ địa phương:",
      },
      {
        key: "noidung_khac",
        name: "Nội dung khác:",
      },
    ];
    return result;
  }, []);
  return (
    <Box
      sx={{
        width: "100%",
        padding: "1rem",
        border: "1px solid #d6d6d6",
        borderRadius: "0.75rem",
      }}
    >
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab
            label="CHI TIẾT CÁC BIỂU MẪU ĐĂNG KÝ"
            {...JsonTool.a11yProps(0)}
          />
          {(isHoiDong ||
            isGroupNumberNine ||
            isGroupNumberOne ||
            isGroupNumberSeven ||
            isGroupNumberEight) && (
            <Tab label="NỘI DUNG BÁO CÁO CẤP XÃ" {...JsonTool.a11yProps(1)} />
          )}
          {(isHoiDong || isGroupNumberNine || isGroupNumberOne) && (
            <Tab label="ĐÁNH GIÁ TỪ CẤP HUYỆN" {...JsonTool.a11yProps(2)} />
          )}
          {(isGroupNumberNine || isGroupNumberOne) && (
            <Tab label="ĐÁNH GIÁ TỪ CẤP TỈNH" {...JsonTool.a11yProps(3)} />
          )}
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Grid container spacing={1}>
          {dataInfor.map((item, index) => (
            <Fragment key={item?.key + index + "inforchamdiem"}>
              <Grid item xs={12} md={3} lg={2}>
                <Typography fontSize={"0.85rem"}>{item?.name}</Typography>
              </Grid>
              <Grid item xs={12} md={9} lg={4}>
                <Typography fontSize={"1rem"} fontWeight={700}>
                  {sanPham?.[item?.key]
                    ? sanPham?.[item?.key]
                    : "Đang cập nhập..."}
                </Typography>
              </Grid>
            </Fragment>
          ))}
        </Grid>
        <Grid item xs={12}>
          {sanPham?.tepdinhkem_phieudangky &&
          sanPham?.tepdinhkem_phieudangky?.length > 0 ? (
            <Grid container spacing={1}>
              <Grid
                container
                style={{
                  color: "#000000",
                  backgroundColor: "#c6e3fa",
                }}
                fontSize={"1rem"}
                fontWeight={600}
                pb={"0.5rem"}
                m={"0.5rem 0"}
                spacing={1}
                borderBottom={"2px solid #3F51B5"}
              >
                <Grid item xs={2}>
                  STT
                </Grid>
                <Grid item xs={8}>
                  Tên tệp đính kèm
                </Grid>
                <Grid item xs={2}>
                  Tải về
                </Grid>
              </Grid>
              {sanPham?.tepdinhkem_phieudangky?.map((tep, index) => (
                <Grid
                  container
                  key={tep?.id + index + "tepdinhkem"}
                  style={{ color: "#000000" }}
                  fontSize={"1rem"}
                  borderBottom={"1px solid #d6d6d6"}
                  pb={"0.5rem"}
                  mb={"0.5rem"}
                  ml={0}
                  spacing={1}
                >
                  <Grid item xs={2}>
                    {index + 1}
                  </Grid>
                  <Grid item xs={8}>
                    {tep?.tentepdinhkem}
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    style={{ paddingTop: "0px" }}
                  >
                    <IconDownload
                      filename={tep?.tepdinhkem}
                      name="phieudangky"
                      onError={handleErrorDownload}
                      noMedia={false}
                    />
                  </Grid>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Grid
              container
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              p="1rem"
              height="100%"
              borderTop={"2px solid #9e9e9e3d"}
            >
              <Typography
                style={{
                  fontSize: "1.25rem",
                  fontWeight: "500",
                  lineHeight: "1.5rem",
                  color: "black",
                }}
              >
                Không có thông tin Tệp đính kèm
              </Typography>
            </Grid>
          )}
        </Grid>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Grid container spacing={1}>
          {dataContent.map((item, index) => (
            <Fragment key={item?.key + index + "inforchamdiem"}>
              <Grid item xs={12} md={3} lg={3}>
                <Typography fontSize={"0.85rem"}>{item?.name}</Typography>
              </Grid>
              <Grid item xs={12} md={9} lg={9}>
                <Typography fontSize={"1rem"} fontWeight={700}>
                  {sanPham?.[item?.key]
                    ? sanPham?.[item?.key]
                    : "Đang cập nhập..."}
                </Typography>
              </Grid>
            </Fragment>
          ))}
        </Grid>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <Grid
          container
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: "0.5rem",
          }}
          p="1rem"
          height="100%"
        >
          {dataChamDiemHoiDongCapHuyen?.length > 0 ? (
            <>
              <Typography
                style={{
                  fontSize: "1.25rem",
                  fontWeight: "500",
                  lineHeight: "1.5rem",
                  color: "black",
                }}
              >
                Ngày đánh giá:{" "}
                {dayjs(dataChamDiemHoiDongCapHuyen[0].ngaycham).isValid()
                  ? dayjs(dataChamDiemHoiDongCapHuyen[0].ngaycham).format(
                      "DD/MM/YYYY"
                    )
                  : dataChamDiemHoiDongCapHuyen[0].ngaycham}
              </Typography>
              <Typography
                style={{
                  fontSize: "1.25rem",
                  fontWeight: "500",
                  lineHeight: "1.5rem",
                  color: "black",
                }}
              >
                Tổng số điểm: {dataChamDiemHoiDongCapHuyen[0].tongdiem} điểm
              </Typography>
            </>
          ) : (
            <Typography
              style={{
                fontSize: "1.25rem",
                fontWeight: "500",
                lineHeight: "1.5rem",
                color: "black",
              }}
            >
              Cấp huyện chưa chấm xong hoặc chưa tổng hợp điểm từ các phiếu
              thành viên chấm!
            </Typography>
          )}
        </Grid>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <Grid
          container
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: "0.5rem",
          }}
          p="1rem"
          height="100%"
        >
          {dataChamDiemHoiDongCapTinh?.length > 0 ? (
            <>
              <Typography
                style={{
                  fontSize: "1.25rem",
                  fontWeight: "500",
                  lineHeight: "1.5rem",
                  color: "black",
                }}
              >
                Ngày đánh giá:{" "}
                {dayjs(dataChamDiemHoiDongCapTinh[0].ngaycham).isValid()
                  ? dayjs(dataChamDiemHoiDongCapTinh[0].ngaycham).format(
                      "DD/MM/YYYY"
                    )
                  : dataChamDiemHoiDongCapTinh[0].ngaycham}
              </Typography>
              <Typography
                style={{
                  fontSize: "1.25rem",
                  fontWeight: "500",
                  lineHeight: "1.5rem",
                  color: "black",
                }}
              >
                Tổng số điểm: {dataChamDiemHoiDongCapTinh[0].tongdiem} điểm
              </Typography>
            </>
          ) : (
            <Typography
              style={{
                fontSize: "1.25rem",
                fontWeight: "500",
                lineHeight: "1.5rem",
                color: "black",
              }}
            >
              Cấp Tỉnh chưa chấm xong hoặc chưa tổng hợp điểm từ các phiếu thành
              thành viên chấm!
            </Typography>
          )}
        </Grid>
      </CustomTabPanel>
    </Box>
  );
}
